import { openModalAction } from "../../../components/Modal/reducer";
import { EXPORT_TYPE_PDF } from "../../../components/SmartTable/ExportDropdown/ExportOverlay";
import { MODAL_EXPORT_LOADING } from "../../../components/SmartTable/ExportDropdown/LoadingModal";
import axios from "../../../axios";
import { handleExportDownload, handleExportError } from "../../../components/SmartTable/ExportDropdown/methods";

/**
 * Triggers a PDF export of a single training card and initiates a file download.
 * Shows the loading modal while the export is generated; handles errors gracefully.
 *
 * @param {Function} trans - i18next translation function.
 * @param {Function} dispatch - Redux dispatch function.
 * @param {object} [row={}] - Training row with `id` and `title`.
 * @param {string} baseRoute - API route for the export endpoint.
 */
export const downloadTrgSingleTraining = (trans, dispatch, row, baseRoute) => {
  dispatch(openModalAction({ name: MODAL_EXPORT_LOADING }));
  axios
    .get(`${baseRoute}`, {
      params: {
        filename: row.title,
        "type": EXPORT_TYPE_PDF,
        "training_id": row.id
      }
    })
    .then(
      (res) => {
        handleExportDownload(res, dispatch, trans);
      },
      () => handleExportError(dispatch, trans)
    );
};
